<!-- TODO:@Roland each select needs an random? ID. must be present in label for="ID of input"-->
<!-- TODO:@Roland add class "next" to select which has to be filled out next by user to add the orange border -->
<!-- TODO:@Roland add class "is-valid" to select for which the validation was successfull -->
<!-- TODO:@Roland add class "is-invalid" to select for which the validation was not successfull -->
<!-- TODO:@Roland add class "is-invalid" to input when empty mandatory field -->

<form [formGroup]="formName">
  <div class="form-floating mt-5">
    <select
      [name]="name"
      [ngClass]="{
        'is-invalid': control.invalid && (control.dirty || control.touched),
        'is-valid': (required ? (control.valid && (control.dirty || control.touched) && (control.value !== '' || control.value === '0')) : (control.valid && (control.value !== '' || control.value === '0') && (control.dirty || control.touched))),
        'ng-untouched': !control.touched,
        'ng-pristine': !control.dirty,
        'custom-valid': (required ? (control.valid && (control.value !== '' || control.value === '0')) : (control.valid && (control.value !== '' || control.value === '0'))),
        'ng-invalid': control.invalid,
        'disabled': readonly === true
      }"
      class="form-control {{cssClasses}}"
      [id]="'select-' + htmlId"
      [formControl]="control"
      style="height: auto; min-height: 58px; padding: 0.625rem"
      (change)="onValueChange($event)"
      (blur)="onBlur()"
    >
      <option [ngValue]="''" disabled>{{ placeholder }}</option>
      <ng-container *ngIf="type === 'Standard'">
        <option *ngFor="let selectValue of values"
                [value]="selectValue['index']"
                [selected]="selectValue['index'] === selectedValue"
        >
          {{ selectValue['name'] }}
        </option>
      </ng-container>
      <ng-container *ngIf="type === 'TelPrefix'">
        <option *ngFor="let selectValue of telPrefixes"
                [value]="selectValue"
                [selected]="selectValue === selectedValue"
        >
          {{ selectValue }}
        </option>
      </ng-container>
      <ng-container *ngIf="dynamicFormSettings">
        <option *ngFor="let selectValue of values" [value]="selectValue.value">
          {{selectValue.option}}
        </option>
      </ng-container>
    </select>

    <label [for]="'select-' + htmlId" class="form-label">
      {{ label }}
    </label>

    <ng-container *ngIf="toolTipMessage">
      <div class="align-self-center ps-3">
        <i class="fa-solid fa-circle-question text-warning fs-3" [tooltip]="toolTipMessage"
           container="align-self-center"
           placement="auto"></i>
      </div>
    </ng-container>
  </div>

  <ng-container *ngIf="control?.invalid && (control?.dirty || control?.touched)">
    <div class="error-message text-warning ps-2">
      <div *ngIf="control?.errors?.['required']">
        <span>{{ 'General.ErrorRequired' | translate }}</span>
      </div>
    </div>
  </ng-container>
</form>
